import { render, staticRenderFns } from "./save-local.vue?vue&type=template&id=5c790fce&scoped=true"
import script from "./save-local.vue?vue&type=script&lang=js"
export * from "./save-local.vue?vue&type=script&lang=js"
import style0 from "./save-local.vue?vue&type=style&index=0&id=5c790fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c790fce",
  null
  
)

export default component.exports